import styled from 'styled-components';

const Stack = styled.div<{ $horizontal?: boolean; $gap?: string }>`
    display: flex;
    flex-direction: ${(props) => (props.$horizontal ? 'row' : 'column')};
    gap: ${(props) => props.$gap ?? '18px'};
`;

export default Stack;
